// zip tab
tabApp.controller('tabZipController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

    //onLoad apply zip
    var initialZip = ZipStorage.getZip();
    $scope.tZip.inputZip = initialZip;

    var strZip = (initialZip || '').toString();
    if (strZip.length > 0 && strZip.length < 5) {
        strZip = ('0000' + strZip).substring(4 + strZip.length - 5);
        $timeout(function() {
            $('#zipCodeInput').val(strZip);
        }, 200);
    }
    $scope.global.locationLabel = strZip;

    //show/hide overlay
    if (!initialZip) {
        $('#dl-zip-off').show();
        //$('#dl-zip-on').hide();
    } else {
        $('#dl-zip-off').hide();
        $('#dl-zip-on').show();
    }

    $scope.tZip.getData = function() {

        $scope.global.hideTabError($scope.tZip);
        $scope.global.loadedDealers = [];

        //$scope.global.allDealers = [];
        $scope.global.filteredDealers = [];

        //validate zip
        var zip = $scope.tZip.inputZip;
        if (!validateInput('zipCodeInput')) {
            // console.log(validateInput('zipCodeInput'))
            //$scope.global.showTabError($scope.tZip, 'No results found. Please try again');
            $scope.tZip.isError = true;
            return;
        } else {
            $scope.tZip.isError = false;
        }

        $scope.global.locationLabel = zip;

        // load data
        $scope.global.getData(zip, $scope.tZip);

        ZipStorage.setZip(zip);

        // only fire tracking on user click not page load
        if (!firstLoad) {
          // tracking
            _satellite.track('dealerlocator_search_zipsubmit');
        }
        firstLoad = false;
    }

}]);